module.exports = __webpack_public_path__ + "static/media/football.2b9e4a57.svg";